import type { ApiErrorBody, ErrorCode } from '@mira/shared/errors'

export class ApiError extends Error {
  readonly status: number
  readonly code: ErrorCode
  readonly details: unknown

  constructor(status: number, body: ApiErrorBody['error']) {
    super(body.message)
    this.status = status
    this.code = body.code
    this.details = body.details
  }
}

type ResponseLike = { ok: boolean; status: number; json(): Promise<unknown> }

/** Awaits a typed-client call; throws ApiError for non-2xx (our `{ error }` shape), else returns JSON. */
export async function unwrap<T>(request: Promise<ResponseLike>): Promise<T> {
  const res = await request
  const body = await res.json().catch(() => null)
  if (res.ok) return body as T
  const error = (body as ApiErrorBody | null)?.error ?? { code: 'internal' as const, message: `HTTP ${res.status}` }
  throw new ApiError(res.status, error)
}
